import {
  highlight,
  searchData,
  sortByMatchRate,
} from '../../../scripts/utils/fuse-search-utils.js';
import {
  MATRIX_SEARCH_COLUMN_END,
  MATRIX_SEARCH_COLUMN_START,
} from '../finder-eccn-matrix.constants.js';

export default async function handleSearchEvent({
  event,
  originalData,
  headers,
  downloadButton,
  tableWrapper,
  placeholders,
  buildTableAndPagination,
  currentDataRef,
}) {
  const { searchValue } = event.detail;

  let currentData;
  if (searchValue) {
    const result = await searchData(
      searchValue,
      originalData,
      headers,
      MATRIX_SEARCH_COLUMN_START,
      MATRIX_SEARCH_COLUMN_END,
    );

    const searchHeaders = headers.slice(
      MATRIX_SEARCH_COLUMN_START,
      MATRIX_SEARCH_COLUMN_END,
    );
    const sorted = sortByMatchRate(result);

    currentData = sorted.map(({ item, matches }) => ({
      ...item,
      ...searchHeaders.reduce((acc, skey) => {
        acc[skey] = highlight(
          item[skey],
          matches.find((m) => m.key === skey),
        );
        return acc;
      }, {}),
    }));
  } else {
    currentData = [...originalData];
  }

  currentDataRef.current = currentData;
  downloadButton.disabled = !currentData.length;

  buildTableAndPagination(tableWrapper, headers, currentData, placeholders);
}
